(() => {
  const initializeNews = (root) => {
    const filters = Array.from(root.querySelectorAll('[data-news-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-news-card]'));
    const lists = Array.from(root.querySelectorAll('[data-news-list]'));
    const status = root.querySelector('[data-news-status]');
    const empty = root.querySelector('[data-news-empty]');
    const pagination = root.querySelector('[data-news-pagination]');
    const previous = root.querySelector('[data-news-page-prev]');
    const next = root.querySelector('[data-news-page-next]');
    const pageCount = root.querySelector('[data-news-page-count]');
    const pageCurrent = root.querySelector('[data-news-page-current]');
    const pageTotal = root.querySelector('[data-news-page-total]');
    const pageSize = Math.max(1, Number.parseInt(root.dataset.newsPageSize || '6', 10));
    const pagesByCategory = new Map();
    const categories = new Set(filters.map((button) => button.dataset.newsFilter));

    if (!filters.length || !cards.length) return;

    const urlState = new URL(window.location.href);
    let activeCategory = urlState.searchParams.get('news_category') || 'all';
    if (!categories.has(activeCategory)) activeCategory = 'all';
    pagesByCategory.set(activeCategory, Math.max(1, Number.parseInt(urlState.searchParams.get('news_page') || '1', 10)));

    const updateUrl = (category, page) => {
      const url = new URL(window.location.href);
      if (category === 'all') url.searchParams.delete('news_category');
      else url.searchParams.set('news_category', category);

      if (page === 1) url.searchParams.delete('news_page');
      else url.searchParams.set('news_page', String(page));

      window.history.replaceState({ category, page }, '', url);
    };

    const applyFilter = (category, requestedPage = pagesByCategory.get(category) || 1, updateAddress = false) => {
      activeCategory = category;
      root.dataset.newsActiveCategory = category;
      const matchingCards = cards.filter((card) => category === 'all' || card.dataset.newsCategory === category);
      const totalPages = Math.max(1, Math.ceil(matchingCards.length / pageSize));
      const currentPage = Math.min(Math.max(1, requestedPage), totalPages);
      const firstIndex = (currentPage - 1) * pageSize;
      const visibleCards = new Set(matchingCards.slice(firstIndex, firstIndex + pageSize));
      pagesByCategory.set(category, currentPage);

      filters.forEach((button) => {
        const active = button.dataset.newsFilter === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      cards.forEach((card) => {
        card.hidden = !visibleCards.has(card);
      });

      lists.forEach((list) => {
        const visibleCount = Array.from(list.querySelectorAll('[data-news-card]')).filter((card) => !card.hidden).length;
        list.dataset.newsVisibleCount = String(visibleCount);
        list.hidden = visibleCount === 0;
      });

      if (empty) empty.hidden = matchingCards.length > 0;
      if (pagination) pagination.hidden = matchingCards.length === 0 || totalPages === 1;
      if (previous) previous.disabled = currentPage === 1;
      if (next) next.disabled = currentPage === totalPages;
      if (pageCurrent) pageCurrent.textContent = String(currentPage).padStart(2, '0');
      if (pageTotal) pageTotal.textContent = String(totalPages).padStart(2, '0');
      if (pageCount) pageCount.setAttribute('aria-label', `Page ${currentPage} of ${totalPages}`);

      if (status) {
        status.textContent = matchingCards.length
          ? `${matchingCards.length} ${matchingCards.length === 1 ? 'story' : 'stories'} in this category. Page ${currentPage} of ${totalPages}.`
          : 'No stories are available in this category yet.';
      }

      if (updateAddress) updateUrl(category, currentPage);
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.newsFilter, 1, true));
    });

    previous?.addEventListener('click', () => applyFilter(activeCategory, (pagesByCategory.get(activeCategory) || 1) - 1, true));
    next?.addEventListener('click', () => applyFilter(activeCategory, (pagesByCategory.get(activeCategory) || 1) + 1, true));

    window.addEventListener('popstate', () => {
      const url = new URL(window.location.href);
      const category = categories.has(url.searchParams.get('news_category')) ? url.searchParams.get('news_category') : 'all';
      const page = Math.max(1, Number.parseInt(url.searchParams.get('news_page') || '1', 10));
      applyFilter(category, page, false);
    });

    applyFilter(activeCategory, pagesByCategory.get(activeCategory), false);
  };

  document.querySelectorAll('[data-mfb-news]').forEach(initializeNews);
})();
